import React from 'react';
import { Card, Placeholder, Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const ProfilePlaceholder: React.FC = () => {
  return (
    <Container>
      <Row>
        {[1, 2, 3].map((_, idx) => (
          <Col key={idx} xs={12} md={4} className="mb-4">
            <Card>
              <Card.Body>
                <Placeholder as={Card.Title} animation="glow">
                  <Placeholder xs={6} />
                </Placeholder>
                <Placeholder as={Card.Text} animation="glow">
                  <Placeholder xs={7} /> <Placeholder xs={4} />{' '}
                  <Placeholder xs={4} /> <Placeholder xs={6} />{' '}
                  <Placeholder xs={8} />
                </Placeholder>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
